import React, {useEffect, useMemo} from "react";
import { useForm } from "react-hook-form";

import {useDispatch} from "react-redux";
import {Button, createStyles, Grid, makeStyles, Paper, Typography} from "@material-ui/core";
import TextFieldController from "../../../components/TextFieldController";
import type {iMeta} from "./index";

const useStyles = makeStyles( (theme: any) =>
    createStyles({
    mainGrid: {
        display: 'flex'
    },
    layout: {
        width: '80%',
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
            marginLeft: 'auto',
            marginRight: 'auto',
        },
        flexWrap: 'nowrap',
    },
    form: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        margin: 6,
        width: '100%',
    },
    fieldGrid: {
            padding: '6px',
        },
    fieldItem: {

        },
    buttonsGrid:{
            display: 'flex',
            flexDirection: 'row',
            justifyContent:  'flex-end'
        }

    }));



// const schema = yup.object().shape({
//     descricao: yup.string().required(`Descrição obrigatoria.`),
// });



// interface iMetaDialog {
//
//     isOpen: boolean,
//     dialogState: (param:boolean) => void,
//     recId?: number | null,
//     registro?: iMeta
// }

const LoginLogoutsDialog = (props ) => {
    const classes = useStyles();
   // const {    } = useForm();
    const { register, handleSubmit } = useForm();

    // const dispatch = useDispatch();

    const  onSubmit = handleSubmit(async data => {
       // await dispatch(postCategoriaItem(data));
        props.dialogState(false);
    });

    // const resetValues = () => {
    //     setValue('descricao', '');
    // }

    // useEffect( () => {
    //     if (props.registro) {
    //         reset(props.registro);
    //     } else {
    //         resetValues();
    //     }
    // }, [ props.registro ]);

    const handleClose = () => {
        props.dialogState(false);
    };

    return (
        <React.Fragment>

                    <Grid container className={classes.mainGrid}>
                    <Paper className={classes.layout}>
                        <Grid item  container className={classes.mainGrid}>
                            <Grid item className={classes.fieldGrid}  sm={12} md={12} lg={12} xl={12} >
                                <Typography variant="h6" gutterBottom>
                                    Item {props.recId}
                                </Typography>
                            </Grid>
                        <form className={classes.form} >
                            <Grid item className={classes.fieldGrid}  sm={12} md={12} lg={12} xl={12} >
                                {/*<TextFieldController control={control} fullWidth={true} name="descricao" label="Descrição" />*/}

                            </Grid>

                            <Grid item className={classes.buttonsGrid}  sm={12} md={12} lg={12} xl={12} >
                                <Button onClick={onSubmit}>Novo</Button>
                                <Button onClick={handleClose}>Fechar</Button>
                            </Grid>
                        </form>
                        </Grid>
                    </Paper>
                </Grid>
        </React.Fragment>
    )
}


export default  (LoginLogoutsDialog);

